import { AxiosError } from 'axios';
import axiosInstance from './AxiosInterceptor';

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface ApiRequestParams {
    url: string;
    method: HttpMethod;
    data?: any;
    headers?: Record<string, string>;
}

export interface ApiResponse<T> {
    success: boolean;
    message: string | null;
    data?: T;
    errorDetail: {
        errorCode: string;
        errorMessage: string;
    }[] | null;
}

const apiRequest = async <T>({
    url,
    method,
    data,
    headers
}: ApiRequestParams): Promise<ApiResponse<T>> => {
    try {
        let token = localStorage.getItem('BookezToken');

        const response: ApiResponse<T> = await axiosInstance({
            url,
            method,
            data,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': headers?.Authorization || `Bearer ${token}`,
                ...headers
            },
        });

        if (response.success) {
            return {
                success: true,  // Access success from response.data
                message: response?.message,  // Access message from response.data
                data: response?.data as T,        // Access data from response.data
                errorDetail: null
            };

        } else {
            return {
                success: false,  // Access success from response.data
                message: response?.message,  // Access message from response.data
                data: {} as T,
                errorDetail: response.errorDetail// Access data from response.data
            };
        }

    } catch (error) {
        // console.log("🚀 ~ error:", error);
        const axiosError = error as AxiosError;
        let errorMsg = axiosError.message || "Something went wrong!";
        return {
            success: false,
            message: errorMsg,
            data: {} as T,
            errorDetail: (axiosError.response?.data as any)?.errorDetail || null,
        };
    }
};

export default apiRequest;
